// services
import { Http, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

// stores
import { paymentInstrumentsStore } from "@retailer/svelte/stores/PaymentInstrumentStore"

// types
import type { HTTPParams } from "@shared/types/HTTP";
import type { PaymentInstrument } from "@shared/types/PaymentInstrument";

const createPaymentInstrument = async (data, url) => {
  const requestData: HTTPParams = {
    method: "POST",
    url,
    data
  }

  let newInstrument: PaymentInstrument;

  const updateStore = (json) => {
    newInstrument = json

    paymentInstrumentsStore.update(prevState => ({
      loaded: true,
      failed: false,
      paymentInstruments: [...prevState.paymentInstruments, newInstrument]
    }))
  }

  const setStoreFailed = () => {
    paymentInstrumentsStore.update(prevState => ({
      loaded: true,
      failed: true,
      ...prevState
    }))
  }

  await Http(requestData, updateStore, setStoreFailed)

  return newInstrument
}

export const get = async () => {
  const baseUrl = "/api/retailer/payment_instruments"

  paymentInstrumentsStore.update(
    (prevState) => ({
      loaded: true,
      failed: false,
      paymentInstruments: prevState.paymentInstruments
    })
  );

  const requestData: HTTPParams = {
    method: "GET",
    url: baseUrl
  }

  const successCB = (json) => {
    paymentInstrumentsStore.set({
      loaded: true,
      failed: false,
      paymentInstruments: json
    })
  }

  const errCB = () => {
    paymentInstrumentsStore.set({
      loaded: true,
      failed: true,
      paymentInstruments: []
    })
  }

  paymentInstrumentsStore.update((paymentInstruments) => ({
    ...paymentInstruments,
    loaded: false,
    failed: false,
  }))

  await Http(requestData, successCB, errCB)
}

export const createBankAccount = async (paymentInstrument: PaymentInstrument) => {

  if (paymentInstrument.instrument_type != "bank_account") return;
  const instrument = await createPaymentInstrument(paymentInstrument, "api/retailer/payment_instruments")
  return instrument
}

export const createCreditCard = async (token: string, nickname: string, set_default: boolean) => {
  const payload = {
    token,
    nickname,
    set_default
  }

  const instrument = await createPaymentInstrument(payload, "api/retailer/payment_instruments/create_card")
  return instrument
}

export const setDefaultInstrument = async (defaultPaymentInstrument: PaymentInstrument, errCB) => {
  const requestData = {
    method: 'PUT',
    url: 'api/retailer/payment_instruments/make_default',
    data: defaultPaymentInstrument
  }

  const res = await HttpPromiseWithEntireResponse(requestData)
  if (res.ok) {
    // refresh the state of the store to the correct default values
    get()
  } else {
    const json = await res.json()
    errCB(json)
  }
}

export const deletePaymentInstrument = async (paymentInstrumentId: number, successCB: () => void, errCB: (r: Response) => void) => {
  const requestData = {
    method: "DELETE",
    url: "api/retailer/payment_instruments/" + paymentInstrumentId
  }

  const res = await HttpPromiseWithEntireResponse(requestData)
  if (res?.ok) {
    successCB()
  } else {
    errCB(res)
  }

  get()
}